import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { utils } from 'src/app/modules/libs/utils';

interface RestrictionsToggleConfig {
  'validateRS'?: boolean;
}

@Component({
  selector: 'cl-editor-restriction-toggle',
  templateUrl: './cl-editor-restriction-toggle.component.html',
  styleUrls: ['./cl-editor-restriction-toggle.component.scss'],
})
export class ClEditorRestrictionToggleComponent implements OnChanges {
  @Input() configuration?: string;
  @Output() configurationChange = new EventEmitter<string>();

  validateRS = false;

  private config: RestrictionsToggleConfig = {};

  ngOnChanges(): void {
    this.config = utils.JSONparse(this.configuration) || {};
    this.validateRS = !!this.config['validateRS'];
  }

  onValidateRSChange(value: boolean): void {
    this.validateRS = value;

    const newConfig: RestrictionsToggleConfig = {
      ...this.config,
      'validateRS': value,
    };

    this.config = newConfig;
    this.configurationChange.emit(JSON.stringify(newConfig));
  }

}